import React from "react";
import "@xyflow/react/dist/style.css";
import Canvas from "./components/Canvas";

const Flow: React.FC = () => {
  return (
    <div id="flow-container" className={"flex flex-col h-screen min-w-280"}>
      <Canvas className="flex-grow" />
    </div>
  );
};

export default Flow;
